import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const formStyles: BoxStyleProps = {
    padding: "space40",
    paddingTop: "space80",
    overflow: "auto"
};

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize70",
    marginBottom: "space60"
};

export const introStyles: TextStyleProps = {
    marginBottom: "space70"
};

export const fieldStyles: BoxStyleProps = {
    marginBottom: "space70"
};

export const cardsContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "space50"
};

export const buttonContainerStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

export const backButtonStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "center",
    border: "none",
    backgroundColor: "transparent",
    color: "colorText",
    cursor: "pointer",
    padding: "space0",
    marginRight: "space40",
    fontSize: "fontSize30",
    outline: "0px",
    _hover: {
        color: "colorTextWeak"
    },
    _focusVisible: {
        boxShadow: "shadowFocus"
    }
};

export const cardStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
    marginBottom: "space40",
    padding: "space50",
    backgroundColor: "colorBackgroundBody",
    borderWidth: "borderWidth10",
    borderStyle: "solid",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius30",
    cursor: "pointer",
    textAlign: "left",
    transition: "background-color 0.2s, border-color 0.2s",
    _hover: {
        backgroundColor: "colorBackgroundStrong"
    },
    _focusVisible: {
        boxShadow: "shadowFocus",
        outline: "0px"
    }
};

export const cardTitleStyles: TextStyleProps = {
    fontSize: "fontSize40",
    fontWeight: "fontWeightSemibold",
    color: "colorText"
};

export const cardSubtitleStyles: TextStyleProps = {
    fontSize: "fontSize20",
    color: "colorTextWeak",
    marginTop: "space10"
};
